import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
export function SafetySection() {
  const checklist = ['Are pregnant', 'Currently have cancer or had cancer recently', 'Are taking photosensitizing medications', 'Use a pacemaker or implanted medical device', 'Recently had steroid injections in the treatment area', 'Are seeking treatment over growth plates (in children)', 'Are seeking treatment over the thyroid gland, ovaries, or testes'];
  const notes = ['Protective eyewear is strictly required for both the patient and provider during treatment.', 'Treatment should only be delivered by properly trained and certified personnel.', 'Individual responses vary widely based on condition, age, and overall health.', 'Multiple treatments are typically needed to achieve optimal results.', 'There is no guarantee of specific results or complete pain resolution.'];
  return <section className="py-20 bg-brand-gray-light" data-id="element-142">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12" data-id="element-144">
          <div className="flex items-center gap-4 mb-8 border-b border-gray-100 pb-6" data-id="element-145">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 flex-shrink-0" data-id="element-146">
              <AlertTriangleIcon className="w-6 h-6" data-id="element-147" />
            </div>
            <div data-id="element-148">
              <h2 className="text-2xl md:text-3xl font-bold text-brand-navy" data-id="element-149">
                Important Safety Information
              </h2>
              <p className="text-gray-500 text-sm mt-1" data-id="element-150">
                Please review before beginning treatment.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-151">
            <div data-id="element-152">
              <h3 className="text-lg font-bold text-brand-navy mb-4" data-id="element-153">
                Notify your provider if you:
              </h3>
              <ul className="space-y-3" data-id="element-154">
                {checklist.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600" data-id="element-155">
                    <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 flex-shrink-0" data-id="element-156" />
                    <span className="text-sm leading-relaxed" data-id="element-157">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-158">
              <h3 className="text-lg font-bold text-brand-navy mb-4" data-id="element-159">
                Important Notes:
              </h3>
              <ul className="space-y-4" data-id="element-160">
                {notes.map((note, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600" data-id="element-161">
                    <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-162" />
                    <span className="text-sm leading-relaxed" data-id="element-163">{note}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}